<p-confirmDialog />
<div class="card">
  <div class="card-content">

    <!-- Stats cards -->
    <div class="stats-cards-row" *ngIf="!loading">
      <div class="stats-card stats-card--total">
        <div class="stats-card-main">
          <span class="stats-card-value">{{ totalCount }}</span>
          <span class="stats-card-label">Total Prospects</span>
          <span class="stats-card-sublabel">In the funnel</span>
        </div>
        <div class="stats-card-icon"><i class="pi pi-users"></i></div>
      </div>
      <div class="stats-card stats-card--info">
        <div class="stats-card-main">
          <span class="stats-card-value">{{ topLeadSource }}</span>
          <span class="stats-card-label">Top Lead Source</span>
          <span class="stats-card-sublabel">Most-common origin</span>
        </div>
        <div class="stats-card-icon"><i class="pi pi-compass"></i></div>
      </div>
    </div>

    <!-- ============ Collapsible filter bar (driven by header filter icon) ============ -->
    <div class="filter-bar filter-bar-collapsible mb-4"
         [class.filter-bar-visible]="pageHeaderService.currentFiltersVisible"
         *ngIf="!loading">
      <div class="filter-bar-filters">
        <div class="filter-field">
          <label class="filter-label">Status</label>
          <p-select [(ngModel)]="selectedStatus" (ngModelChange)="applyFilters()"
            [options]="statusFilterOptions" optionLabel="label" optionValue="value"
            placeholder="All" [showClear]="true"
            panelStyleClass="filter-dropdown-panel" appendTo="body" />
        </div>
        <div class="filter-field">
          <label class="filter-label">Industry</label>
          <p-select [(ngModel)]="selectedIndustry" (ngModelChange)="applyFilters()"
            [options]="industryOptions" optionLabel="label" optionValue="value"
            placeholder="All industries" [showClear]="true" [filter]="true" filterPlaceholder="Search…"
            panelStyleClass="filter-dropdown-panel" appendTo="body" />
        </div>
        <div class="filter-field">
          <label class="filter-label">Country</label>
          <p-select [(ngModel)]="selectedCountry" (ngModelChange)="applyFilters()"
            [options]="countryOptions" optionLabel="label" optionValue="value"
            placeholder="All countries" [showClear]="true" [filter]="true" filterPlaceholder="Search…"
            panelStyleClass="filter-dropdown-panel" appendTo="body" />
        </div>
      </div>
      <div class="filter-bar-actions" *ngIf="hasActiveFilters()">
        <button type="button" class="btn-clear-filters" (click)="clearFilters()" title="Clear all filters">
          <i class="pi pi-filter-slash"></i>
        </button>
      </div>
    </div>

    <!-- Table -->
    <p-table
      [scrollable]="true"
      scrollHeight="flex"
      [value]="filteredClients"
      [loading]="loading"
      [paginator]="filteredClients.length > 15"
      [alwaysShowPaginator]="false"
      [rows]="15"
      [showCurrentPageReport]="true"
      currentPageReportTemplate="Showing {first} to {last} of {totalRecords} presales clients"
      [tableStyle]="{ 'min-width': '100%' }"
      styleClass="p-datatable no-column-lines presales-clients-table">

      <ng-template pTemplate="header">
        <tr>
          <th pSortableColumn="name">Client <p-sortIcon field="name" /></th>
          <th>Primary Contact</th>
          <th pSortableColumn="industry" style="width: 130px;">Industry <p-sortIcon field="industry" /></th>
          <th pSortableColumn="country" style="width: 140px;">Country <p-sortIcon field="country" /></th>
          <th pSortableColumn="leadSource" style="width: 180px;">Lead Source <p-sortIcon field="leadSource" /></th>
          <th class="th-actions" style="width: 110px;">Actions</th>
        </tr>
      </ng-template>

      <ng-template pTemplate="body" let-client>
        <tr [class.row-inactive]="client.isActive === false">
          <td>
            <div class="client-name-cell">
              <span class="client-name">{{ client.name }}</span>
              <span class="client-website" *ngIf="client.companyWebsite">{{ client.companyWebsite }}</span>
            </div>
          </td>
          <td>
            <div class="contact-cell" *ngIf="client.contactPerson || client.contactEmail">
              <span class="contact-name" *ngIf="client.contactPerson">{{ client.contactPerson }}</span>
              <span class="contact-email" *ngIf="client.contactEmail">{{ client.contactEmail }}</span>
            </div>
            <span class="text-muted" *ngIf="!client.contactPerson && !client.contactEmail">—</span>
          </td>
          <td>
            <span class="industry-pill" *ngIf="client.industry">{{ client.industry }}</span>
            <span class="text-muted" *ngIf="!client.industry">—</span>
          </td>
          <td>{{ client.country || '—' }}</td>
          <td>
            <span class="lead-source" *ngIf="client.leadSource">{{ client.leadSource }}</span>
            <span class="text-muted" *ngIf="!client.leadSource">—</span>
          </td>
          <td class="table-cell-actions">
            <div class="table-actions-stack">
              <p-button
                *ngIf="canManagePresales && !client.promotedToClientId"
                [icon]="client.isActive ? 'pi pi-check-circle' : 'pi pi-times-circle'"
                [severity]="client.isActive ? 'success' : 'secondary'"
                [text]="true"
                size="small"
                [pTooltip]="client.isActive ? 'Active' : 'Inactive'" tooltipPosition="top"
                (onClick)="toggleActive(client)" />
              <p-button
                *ngIf="canManagePresales"
                icon="pi pi-pencil"
                [text]="true"
                severity="info"
                size="small"
                pTooltip="Edit" tooltipPosition="top"
                (onClick)="showEditDialog(client)" />
            </div>
          </td>
        </tr>
      </ng-template>

      <ng-template pTemplate="emptymessage">
        <tr class="table-empty-row">
          <td colspan="7" class="table-empty-cell">
            <div class="empty-state">
              <div class="empty-icon"><i class="pi pi-inbox"></i></div>
              <p class="empty-message">No presales clients yet</p>
              <p class="empty-description">Click "Add Presales Client" in the header to add your first prospect.</p>
            </div>
          </td>
        </tr>
      </ng-template>
    </p-table>
  </div>
</div>


<!-- ================= Add / Edit dialog ================= -->
<p-dialog
  [visible]="displayDialog"
  (visibleChange)="displayDialog = $event"
  [header]="isEditMode ? 'Edit Presales Client' : 'Add Presales Client'"
  [modal]="true"
  styleClass="dialog-lg"
  [dismissableMask]="true"
  [closable]="true">

  <div class="form-dialog-form">
    <div class="form-dialog-container">

      <div class="emp-section-title"><i class="pi pi-building"></i> Basic Information</div>

      <div class="form-row">
        <div class="field" [class.field-invalid]="fieldTouched['name'] && !selectedClient.name.trim()">
          <label for="name">Client Name <span class="required-star">*</span></label>
          <input pInputText id="name" [(ngModel)]="selectedClient.name" placeholder="e.g., Ceylinco General Insurance"
            (blur)="fieldTouched['name'] = true" />
          <small class="field-error" *ngIf="fieldTouched['name'] && !selectedClient.name.trim()">Client name is required</small>
        </div>
      </div>

      <div class="form-row">
        <div class="field">
          <label for="description">Description</label>
          <textarea id="description" [(ngModel)]="selectedClient.description" [rows]="2"
            placeholder="Brief description of the client company"></textarea>
        </div>
      </div>

      <div class="form-row">
        <div class="field">
          <label for="website">Company Website</label>
          <input pInputText id="website" [(ngModel)]="selectedClient.companyWebsite" placeholder="https://www.example.com" />
        </div>
      </div>

      <div class="emp-section-title"><i class="pi pi-user"></i> Primary Contact</div>

      <div class="form-row two-columns">
        <div class="field">
          <label for="contactPerson">Contact Person Name</label>
          <input pInputText id="contactPerson" [(ngModel)]="selectedClient.contactPerson" placeholder="e.g., Priyanka Fernando" />
        </div>
        <div class="field">
          <label for="contactEmail">Contact Email</label>
          <input pInputText id="contactEmail" type="email" [(ngModel)]="selectedClient.contactEmail" placeholder="name@company.com" />
        </div>
      </div>

      <div class="form-row">
        <div class="field">
          <label for="contactPhone">Contact Phone</label>
          <input pInputText id="contactPhone" type="tel" [(ngModel)]="selectedClient.contactPhone" placeholder="+94 77 123 4567" />
          <small class="field-hint">Include country code for international contacts.</small>
        </div>
      </div>

      <div class="emp-section-title"><i class="pi pi-tag"></i> Categorization</div>

      <div class="form-row two-columns">
        <div class="field">
          <label for="industry">Industry</label>
          <p-select id="industry" [(ngModel)]="selectedClient.industry"
            [options]="industryOptions" optionLabel="label" optionValue="value"
            placeholder="Select industry" [showClear]="true" appendTo="body" [filter]="true" filterPlaceholder="Search…" />
        </div>
        <div class="field">
          <label for="country">Country</label>
          <p-select id="country" [(ngModel)]="selectedClient.country"
            [options]="countryOptions" optionLabel="label" optionValue="value"
            placeholder="Select country" [showClear]="true" appendTo="body" [filter]="true" filterPlaceholder="Search…" />
        </div>
      </div>

      <div class="form-row">
        <div class="field">
          <label for="leadSource">Lead Source</label>
          <p-select id="leadSource" [(ngModel)]="selectedClient.leadSource"
            [options]="leadSourceOptions" optionLabel="label" optionValue="value"
            placeholder="How did we find this lead?" [showClear]="true" appendTo="body" />
          <small class="field-hint">Used in the "Top Lead Source" stat and win-rate reports.</small>
        </div>
      </div>

      <div class="emp-section-title"><i class="pi pi-file"></i> Notes</div>

      <div class="form-row">
        <div class="field">
          <label for="notes">Notes</label>
          <textarea id="notes" [(ngModel)]="selectedClient.notes" [rows]="3"
            placeholder="Procurement style, key decision makers, budget cycles, past experiences…"></textarea>
        </div>
      </div>

      <div class="form-row" *ngIf="isEditMode">
        <div class="field">
          <div class="checkbox-item">
            <p-checkbox [(ngModel)]="selectedClient.isActive" [binary]="true" inputId="isActive" />
            <label for="isActive" class="checkbox-label">Active — include in dropdowns and reports</label>
          </div>
        </div>
      </div>

    </div>
  </div>

  <ng-template pTemplate="footer">
    <div class="form-dialog-footer-btns">
      <p-button label="Cancel" icon="pi pi-times" (onClick)="hideDialog()" severity="secondary" [outlined]="true" />
      <p-button label="Save Client" icon="pi pi-check" (onClick)="saveClient()" severity="primary" />
    </div>
  </ng-template>
</p-dialog>
